module.exports = __webpack_public_path__ + "prod/1.42.2/img/left-ele.67136c85.gif";